import { Col, Row } from "antd";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import {
  MILTIS_CSP_PROFESSIONS,
  SUBSCRIPTION_FORM_KEYS,
} from "utils/constants";

const Activity = ({
  setPercent,
  isFieldRequired,
  initialValues,
  bindField,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });

  const PROFESSION_OPTIONS = useMemo(
    () =>
      MILTIS_CSP_PROFESSIONS.map((item) => ({
        value: item.value,
        label: item.label,
      })),
    [],
  );

  const professionPath = "project.contact.profession";
  const professionField = bindField(professionPath, {
    label: SUBSCRIPTION.FORM.PROFESSION.LABEL,
    required: isFieldRequired(professionPath),
    // disabled: true,
    onBlur: () => setPercent(initialValues),
  });

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.ACTIVITY}-section`}
    >
      <Form
        type="vertical"
        title={SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.ACTIVITY.TITLE}
      >
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <FormField
              path={professionField.path}
              label={professionField.label}
              required={professionField.required}
              disabled={professionField.disabled}
            >
              {(field) => (
                <Select
                  options={PROFESSION_OPTIONS}
                  placeholder={SUBSCRIPTION.FORM.PROFESSION.PLACEHOLDER}
                  label={professionField.label}
                  defaultValue={professionField.defaultValue}
                  {...field}
                  onChange={professionField.onChange}
                  onBlur={professionField.onBlur}
                />
              )}
            </FormField>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Activity;
